import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ErrorLoggerService,
  type ErrorLog,
} from '../../services/error-logger.service';
import { Observable, firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-error-logger-panel',
  imports: [CommonModule],
  templateUrl: './error-logger-panel.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './error-logger-panel.scss',
})
export class ErrorLoggerPanel {
  private errorLogger = inject(ErrorLoggerService);
  private authService = inject(AuthService);

  errors$: Observable<ErrorLog[]> = this.errorLogger.errors;
  showPanel$: Observable<boolean> = this.errorLogger.showErrorPanel;

  toggle(): void {
    this.errorLogger.toggleErrorPanel();
  }

  clear(): void {
    this.errorLogger.clearErrors();
  }

  async prepareLogsForEmail(): Promise<void> {
    const logs = await firstValueFrom(this.errors$);
    const userProfile = this.authService.userProfile();
    const email = userProfile?.mail || userProfile?.userPrincipalName || '';

    const payload = {
      toEmail: email,
      subject: `MyFruit Mobile Logs - ${new Date().toLocaleString()}`,
      preparedAt: new Date().toISOString(),
      app: {
        name: 'MyFruit2.0 Mobile',
        version: environment.version,
        url: window.location.href,
      },
      user: {
        id: userProfile?.id || '',
        displayName: userProfile?.displayName || '',
        email,
      },
      device: {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform:
          (navigator as Navigator & { userAgentData?: { platform?: string } })
            .userAgentData?.platform || 'unknown',
        online: navigator.onLine,
      },
      logSummary: {
        total: logs.length,
        errors: logs.filter((log) => log.level === 'error').length,
        warnings: logs.filter((log) => log.level === 'warn').length,
        info: logs.filter((log) => log.level === 'info').length,
      },
      logs,
    };

    console.log('📧 Prepared logs payload for email API:', payload);
  }

  getLevelColor(level: string): string {
    switch (level) {
      case 'error':
        return 'text-red-600';
      case 'warn':
        return 'text-yellow-600';
      case 'info':
        return 'text-blue-600';
      default:
        return 'text-gray-600';
    }
  }
}
